export const styles: Record<string, React.CSSProperties> = {
  wrap: {
    position: "relative",
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    overflow: "hidden",
    background:
      "radial-gradient(1200px 800px at 20% 10%, rgba(120, 119, 198, 0.35), transparent 60%)," +
      "radial-gradient(900px 600px at 80% 30%, rgba(56, 189, 248, 0.25), transparent 55%)," +
      "linear-gradient(180deg, #05070b 0%, #090a12 55%, #05070b 100%)",
    color: "#fff",
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji"',
  },
  center: {
    position: "relative",
    zIndex: 2,
    height: "100%",
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    padding: 24,
  },
  card: {
    width: "80vw",
    borderRadius: 20,
    padding: 28,
    background: "rgba(15, 18, 28, 0.72)",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.55)",
    backdropFilter: "blur(10px)",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 28,
    padding: "0 10px",
    borderRadius: 999,
    fontSize: 12,
    letterSpacing: 0.8,
    fontWeight: 700,
    color: "rgba(255,255,255,0.9)",
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.10)",
    marginBottom: 14,
  },
  h1: {
    margin: 0,
    fontSize: 28,
    lineHeight: 1.15,
    letterSpacing: -0.4,
  },
  p: {
    marginTop: 10,
    marginBottom: 18,
    fontSize: 14.5,
    lineHeight: 1.6,
    color: "rgba(255,255,255,0.78)",
  },
  pathRow: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    marginBottom: 16,
    padding: "10px 12px",
    borderRadius: 12,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.08)",
  },
  pathLabel: {
    fontSize: 12,
    color: "rgba(255,255,255,0.65)",
  },
  pathCode: {
    fontSize: 12,
    color: "rgba(255,255,255,0.85)",
  },
  inputRow: {
    display: "flex",
    gap: 10,
    marginTop: 10,
  },
  input: {
    flex: 1,
    height: 42,
    borderRadius: 12,
    padding: "0 12px",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    color: "#fff",
    outline: "none",
  },
  primaryBtn: {
    height: 42,
    padding: "0 14px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.18)",
    background:
      "linear-gradient(135deg, rgba(56,189,248,0.95) 0%, rgba(120,119,198,0.95) 100%)",
    color: "#071018",
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  btnRow: {
    display: "flex",
    gap: 10,
    marginTop: 14,
    flexWrap: "wrap",
  },
  secondaryBtn: {
    height: 40,
    padding: "0 14px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.16)",
    background: "rgba(255,255,255,0.08)",
    color: "rgba(255,255,255,0.92)",
    cursor: "pointer",
    fontWeight: 600,
  },
  ghostBtn: {
    height: 40,
    padding: "0 14px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.12)",
    background: "transparent",
    color: "rgba(255,255,255,0.82)",
    cursor: "pointer",
    fontWeight: 600,
  },
  footer: {
    marginTop: 16,
    fontSize: 12.5,
    color: "rgba(255,255,255,0.58)",
  },
  blobA: {
    position: "absolute",
    inset: "auto auto -120px -120px",
    width: 360,
    height: 360,
    borderRadius: 999,
    background: "rgba(120, 119, 198, 0.30)",
    filter: "blur(40px)",
    animation: "floatA 10s ease-in-out infinite",
    zIndex: 1,
  },
  blobB: {
    position: "absolute",
    inset: "-140px -140px auto auto",
    width: 420,
    height: 420,
    borderRadius: 999,
    background: "rgba(56, 189, 248, 0.22)",
    filter: "blur(50px)",
    animation: "floatB 12s ease-in-out infinite",
    zIndex: 1,
  },
};